export default function(x) {
  return x;
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-scale/~/d3-format/src/identity.js
// module id = 980
// module chunks = 0